import {
    getCurrentEnvironment,
    EnvironmentType
} from '../../diagnostics/EnvironmentType'

export class EndpointNames {
    public static CLIENT_SERVICE = 'client-service'
    public static JOB_SERVICE = 'job-service'
    public static JOB_REQUEST_SERVICE = 'job-request-service'
    public static BIDDING_SERVICE = 'bidding-service'
    public static ATTACHMENT_SERVICE = 'attachment-service'
    public static RATING_SERVICE = 'rating-service'
    public static PAYMENT_SERVICE = 'payment-service'
    public static MSA_SERVICE = 'msa-service'
    public static EMAIL_SERVICES = 'email-service'
    public static PREFERENCES_SERVICE = 'preferences-service'
    public static POST_MESSAGE = 'post-message'
    public static MESSAGING_SERVICE = 'messaging-service'
    public static DISPATCHER_SERVICE = 'dispatcher-service'
    public static LOG_SERVICE = 'log-service'
}

export const CLIENT_ID =
    getCurrentEnvironment() === EnvironmentType.DEV
        ? '2io3pic1p5e0rqu55dh49vq98e'
        : getCurrentEnvironment() === EnvironmentType.STAGE
        ? '214mhth3g0hqfe1lekdbdcf76u'
        : '1ur06i2emu3i86rkj26mdfeqjf'

export const REDIRECT_URI_LOGIN = window.location.origin + '/#/signin'
export const REDIRECT_URI_LOGOUT = window.location.origin + '/#/signin'
export const AUTH_URL =
    'https://gt2-client-stage.auth.us-west-2.amazoncognito.com'

let PROD_ENDPOINTS_MAP: Map<string, string> = new Map<string, string>()
PROD_ENDPOINTS_MAP.set(
    EndpointNames.JOB_SERVICE,
    'https://jny1hhb5zf.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.JOB_REQUEST_SERVICE,
    'https://nuu13eziue.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.BIDDING_SERVICE,
    'https://0ii368oovd.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.ATTACHMENT_SERVICE,
    'https://lfy517rxb7.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.RATING_SERVICE,
    'https://pry058xv90.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.CLIENT_SERVICE,
    'https://upk6j5gunl.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.PAYMENT_SERVICE,
    'https://9lpm7zr9sb.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.MSA_SERVICE,
    'https://fdvwk1p3s9.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.PREFERENCES_SERVICE,
    'https://3vkhcjc845.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.EMAIL_SERVICES,
    'https://sfezkbum3b.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.MESSAGING_SERVICE,
    'https://8eq7br9pkc.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.POST_MESSAGE,
    'https://gotrashy.staging.wpengine.com/'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.DISPATCHER_SERVICE,
    'https://3pxwuda3ed.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.LOG_SERVICE,
    'https://ejwn2t8vp7.execute-api.us-west-2.amazonaws.com/prod'
)
PROD_ENDPOINTS_MAP.set(
    EndpointNames.JOB_REQUEST_SERVICE,
    'https://nuu13eziue.execute-api.us-west-2.amazonaws.com/prod'
)

let STAGE_ENDPOINTS_MAP: Map<string, string> = new Map<string, string>()
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.CLIENT_SERVICE,
    'https://8rvh4zg2sj.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.JOB_SERVICE,
    'https://gbngeihu27.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.BIDDING_SERVICE,
    'https://9y0vctl5b9.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.ATTACHMENT_SERVICE,
    'https://b38jp3dkab.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.RATING_SERVICE,
    'https://otw7h33g90.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.PAYMENT_SERVICE,
    'https://9obyvdyq1m.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.MSA_SERVICE,
    'https://nufevwd203.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.EMAIL_SERVICES,
    'https://obg5v8lff5.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.PREFERENCES_SERVICE,
    'https://e6g8ls3m74.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.MESSAGING_SERVICE,
    'https://onpb2nzwz3.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.POST_MESSAGE,
    'https://gotrashy.staging.wpengine.com/'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.DISPATCHER_SERVICE,
    'https://ljvjti8lqd.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.LOG_SERVICE,
    'https://kly5jdb7ei.execute-api.us-west-2.amazonaws.com/stage'
)
STAGE_ENDPOINTS_MAP.set(
    EndpointNames.JOB_REQUEST_SERVICE,
    'https://vpyh7uyv8i.execute-api.us-west-2.amazonaws.com/stage'
)

let DEV_ENDPOINTS_MAP: Map<string, string> = new Map<string, string>()
DEV_ENDPOINTS_MAP.set(
    EndpointNames.JOB_SERVICE,
    'https://4h12wxasbh.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.BIDDING_SERVICE,
    'https://d4nnufl8s4.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.ATTACHMENT_SERVICE,
    'https://smdgsk1i3g.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.RATING_SERVICE,
    'https://1e66v4oau5.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.CLIENT_SERVICE,
    'https://y9w8x70mga.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.PAYMENT_SERVICE,
    'https://wnrg6gd1jd.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.MSA_SERVICE,
    'https://zbtzrntqq2.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.PREFERENCES_SERVICE,
    'https://369p4sa12l.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.EMAIL_SERVICES,
    'https://y1jenkz1ji.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.MESSAGING_SERVICE,
    'https://aewhufk7j8.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.POST_MESSAGE,
    'https://gotrashy.staging.wpengine.com/'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.DISPATCHER_SERVICE,
    'https://lsp0i0dv30.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.LOG_SERVICE,
    'https://2vvkepxh6d.execute-api.us-west-2.amazonaws.com/dev'
)
DEV_ENDPOINTS_MAP.set(
    EndpointNames.JOB_REQUEST_SERVICE,
    'https://g5m0eumvy8.execute-api.us-west-2.amazonaws.com/dev'
)

let env = getCurrentEnvironment()
export const ENDPOINTS_MAP =
    env === EnvironmentType.DEV
        ? DEV_ENDPOINTS_MAP
        : env === EnvironmentType.STAGE
        ? STAGE_ENDPOINTS_MAP
        : PROD_ENDPOINTS_MAP



// WEBPACK FOOTER //
// ./src/config/api/apiConfig.ts